module.exports = __webpack_public_path__ + "static/media/PricingNote_IPOIntelligence_base.0ab92a56.png";